module.exports = __webpack_public_path__ + "img/gundarium-hint.a0a8d253.jpg";